/**
 * Appearance preferences from the Cosmos user doc (`uiPreferences`) applied to
 * ThemeContext, and the one-shot sidebar entrance played right after sign-in.
 *
 * Shared by MainLayout (server sync on every load) and Login (applied BEFORE
 * navigating into the app, so the first frame of the shell is already the
 * user's layout and Classic never flashes for a New-look user).
 */

const UI_SHELL_IDS = ['classic', 'inset'];
const SHELL_ENTRANCE_KEY = 'lodgeic:shellEntrance';

export const shellFromPreferences = (prefs) =>
  (prefs && UI_SHELL_IDS.includes(prefs.shell) ? prefs.shell : null);

/** Apply whatever the doc carries that differs from the local copy. */
export function applyUiPreferences(theme, prefs) {
  if (!prefs || !theme) return;
  const t = theme;
  const shell = shellFromPreferences(prefs);
  if (shell && shell !== t.uiShell) t.setUiShell(shell);
  if (prefs.sidebarCustomColor && prefs.sidebarCustomColor !== t.sidebarCustomColor) {
    t.setSidebarCustomColor(prefs.sidebarCustomColor); // also selects 'custom'
  }
  if (prefs.sidebarTheme && prefs.sidebarTheme !== (prefs.sidebarCustomColor ? 'custom' : t.sidebarTheme)) {
    t.setSidebarTheme(prefs.sidebarTheme);
  }
  if (prefs.chartCustomColor && prefs.chartCustomColor !== t.chartCustomColor) t.setChartCustomColor(prefs.chartCustomColor);
  if (prefs.chartPalette && prefs.chartPalette !== 'custom' && prefs.chartPalette !== t.chartPalette) t.setChartPalette(prefs.chartPalette);
  if (prefs.panelCustomColor && JSON.stringify(prefs.panelCustomColor) !== JSON.stringify(t.panelCustomColorByMode)) {
    t.setPanelCustomColors(prefs.panelCustomColor);
  }
  if (prefs.panelTheme && JSON.stringify(prefs.panelTheme) !== JSON.stringify(t.panelThemeByMode)) t.setPanelThemes(prefs.panelTheme);
}

/** Ask the inset shell to play its entrance (sidebar slides in, then expands) on its next mount. */
export function markShellEntrance() {
  try { sessionStorage.setItem(SHELL_ENTRANCE_KEY, '1'); } catch (e) { /* private mode */ }
}

/** Entrance flagged and not yet consumed (skeletons draw the rail collapsed). */
export function isShellEntrancePending() {
  try { return sessionStorage.getItem(SHELL_ENTRANCE_KEY) === '1'; } catch (e) { return false; }
}

/** True once, right after markShellEntrance(); cleared on read. */
export function consumeShellEntrance() {
  try {
    const flagged = sessionStorage.getItem(SHELL_ENTRANCE_KEY) === '1';
    if (flagged) sessionStorage.removeItem(SHELL_ENTRANCE_KEY);
    return flagged;
  } catch (e) {
    return false;
  }
}
